import { defineStore, acceptHMRUpdate } from 'pinia'

export const useRedactorStore = defineStore({
  id: 'redactor',
  state: () => {
    return {
      isRedacting: false,
      redactorData: null,
      photos: [],
      officePhotosToSave: [],
      officePhotosToDelete: []
    }
  },
  actions: {
    enableRedactingMode() {
      this.$patch({
        isRedacting: true
      })
    },
    setRedactorDataIfEmpty(data: object) {
      if (!this.redactorData) {
        this.$patch({
          redactorData: data
        })
      }
    },
    updateRedactorData(key: string, value: any) {
      this.redactorData[key] = value
    },
    changeRedacting() {
      this.$patch({
        isRedacting: !this.isRedacting
      })
    },
    addPhoto(templateId: number, templatePath: string, file) {
      this.photos.push({
        templateId,
        templatePath,
        file
      })
    },
    clearPhotos() {
      this.photos = []
    },
    deletePreviewPhoto(templateId:number, templatePath: string) {
      this.photos = this.photos.filter(photo => photo.templateId !== templateId && photo.templatePath !== templatePath)
    },
    setOfficePhotosToSave(photos) {
      this.$patch({
        officePhotosToSave: photos
      })
    },
    setOfficePhotosToDelete(photos) {
      this.$patch({
        officePhotosToDelete: photos
      })
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRedactorStore, import.meta.hot))
}
